export class AbortError extends Error {
    constructor(msg, reason) {
        super(msg);
        this.name = 'AbortError';
        this.message = msg;
        this.reason = reason;
    }
}
export const isAbortError = (err) => {
    return err instanceof Error && 'reason' in err && err.name === 'AbortError';
};
